import { render } from "./NumberOfPagers.vue?vue&type=template&id=34309fcb"
import script from "./NumberOfPagers.vue?vue&type=script&lang=ts"
export * from "./NumberOfPagers.vue?vue&type=script&lang=ts"
script.render = render

export default script